import { isNil } from 'lodash';
import { CUSTOMER_TYPE } from '../components/OfferConversionHistoryDrawer/types';

export enum OFFER_STATUS_TYPE {
    ACTIVE = 'Active',
    DELETED = 'DELETED',
    FAILED = 'Failed',
    PAUSED = 'Paused',
    DEACTIVATING = 'Deactivating',
    DEACTIVATED = 'Deactivated',
    DELETING = 'Removing',
    GENERATING = 'Generating',
    EXPIRED = 'Expired',
    UPCOMING = 'Upcoming',
    FAILED_UPDATE = 'Update Failed',
}

export enum CONVERSION_STATUS {
    ACCEPTED = 'Accepted',
    REJECTED = 'Rejected',
    CANCELED = 'Canceled',
    DUPLICATE = 'Duplicate',
}

enum TagType {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
    Processing = 'processing',
    Default = 'default',
}

const successTypes = [
    OFFER_STATUS_TYPE.ACTIVE, OFFER_STATUS_TYPE.ACTIVE.toLocaleUpperCase(),
    CONVERSION_STATUS.ACCEPTED, CONVERSION_STATUS.ACCEPTED.toLocaleUpperCase(),
];
const warningTypes = [
    OFFER_STATUS_TYPE.PAUSED, OFFER_STATUS_TYPE.PAUSED.toLocaleUpperCase(),
    CONVERSION_STATUS.CANCELED, CONVERSION_STATUS.CANCELED.toLocaleUpperCase(),
    CONVERSION_STATUS.DUPLICATE, CONVERSION_STATUS.DUPLICATE.toLocaleLowerCase(),
];
const errorTypes = [
    OFFER_STATUS_TYPE.FAILED, OFFER_STATUS_TYPE.EXPIRED,
    OFFER_STATUS_TYPE.FAILED.toLocaleUpperCase(), OFFER_STATUS_TYPE.EXPIRED.toLocaleUpperCase(),
    OFFER_STATUS_TYPE.DELETED, OFFER_STATUS_TYPE.DELETED.toLocaleUpperCase(),
    CONVERSION_STATUS.REJECTED, CONVERSION_STATUS.REJECTED.toLocaleUpperCase(),
    OFFER_STATUS_TYPE.DEACTIVATING, OFFER_STATUS_TYPE.DEACTIVATING.toLocaleUpperCase(),
    OFFER_STATUS_TYPE.DEACTIVATED, OFFER_STATUS_TYPE.DEACTIVATED.toLocaleUpperCase(),
    OFFER_STATUS_TYPE.FAILED_UPDATE, OFFER_STATUS_TYPE.FAILED_UPDATE.toLocaleUpperCase(),
];
const processingTypes = [
    OFFER_STATUS_TYPE.GENERATING, OFFER_STATUS_TYPE.GENERATING.toLocaleUpperCase(),
    OFFER_STATUS_TYPE.UPCOMING, OFFER_STATUS_TYPE.UPCOMING.toLocaleUpperCase(),
];

export const getTagType = (type: OFFER_STATUS_TYPE | CONVERSION_STATUS): TagType => {
  if (successTypes.includes(type)) {
    return TagType.Success;
  } else if (warningTypes.includes(type)) {
    return TagType.Warning;
  } else if (errorTypes.includes(type)) {
    return TagType.Error;
  } else if (processingTypes.includes(type)) {
    return TagType.Processing;
  } else {
    return TagType.Default;
  }
  };
  export const getCustomerType = (isNewCustomer): string => {
    if (isNil(isNewCustomer)) {
      return '';
    }
    if (isNewCustomer) {
      return CUSTOMER_TYPE.NEW_CUSTOMER;
    }
    return CUSTOMER_TYPE.RETURNING_CUSTOMER;
  };
